import { render, staticRenderFns } from "./News.vue?vue&type=template&id=3e624c5e&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"
import style0 from "./News.vue?vue&type=style&index=0&id=3e624c5e&prod&lang=scss&scoped=true"
import style1 from "./News.vue?vue&type=style&index=1&id=3e624c5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e624c5e",
  null
  
)

export default component.exports